import React from "react";
import { useTranslation } from "react-i18next";

/** Partner identity, overview and capabilities in a shared editorial layout. */
export default function PartnerSection({ partnerKey, logo, name, icons, warm = false }) {
  const { t } = useTranslation();
  const content = t(`pages.partners.details.${partnerKey}`, { returnObjects: true });
  const headingId = `partner-${partnerKey}-title`;

  return (
    <section aria-labelledby={headingId} className={`px-5 py-32 text-main-dark md:px-6 md:py-44 ${warm ? "bg-gray" : "bg-white"}`}>
      <div className="mx-auto max-w-xl text-left">
        <div className="grid items-center gap-8 md:grid-cols-[minmax(0,1fr)_280px] md:gap-16">
          <h2 id={headingId} className="mb-0 max-w-[32ch] scroll-mt-28 text-3xl font-bold leading-tight md:text-4xl">{content.title}</h2>
          <div className="flex flex-col items-start gap-3">
            <img src={logo} alt={name} loading="lazy" className="h-auto max-h-44 w-full max-w-[17.5rem] object-contain object-left" />
          </div>
        </div>

        <div className="flex max-w-[75ch] flex-col gap-5 pt-6 pb-9 md:pt-8 md:pb-12">
          {content.statement && (
            <p className="mb-0 text-lg font-medium leading-relaxed text-main-dark">{content.statement}</p>
          )}
          <p className="mb-0 text-lg leading-relaxed text-secondary">{content.description}</p>
        </div>

        <div className="grid gap-8 rounded-2xl bg-main px-7 py-9 text-white md:grid-cols-3 md:gap-9 md:px-10 md:py-10">
          {content.features.map((feature, index) => {
            const Icon = icons[index];
            return (
              <div key={feature.title}>
                <Icon aria-hidden="true" className="mb-5 h-10 w-10 text-contrast-light" strokeWidth={1.5} />
                <h3 className="mb-3 text-xl font-bold leading-snug">{feature.title}</h3>
                <p className="mb-0 text-base leading-relaxed text-white/85">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
